import React from 'react';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import Divider from '@mui/material/Divider';

const informationTexts = [
    { severity: "error", code: "2001", message: "Please enter Informatica Workflow XML and then try again." },
    { severity: "error", code: "3001", message: "Encountered either a new Informatica Workflow XML or unknown XML format. Our technical team will get in touch with you to help you out or feel free to email us at contact@agility1st.com." },
	{ severity: "info", code: "5001", message: "Your workflow uses some premium features. Login with your LinkedIn login, and then try again!" },
	{ severity: "info", code: "9001", message: "SQL Complexity exceeds allowed in free version. To access full features, please use corporate login or send request to info@agility1st.com!" },
	{ severity: "success", code: "success", message: "Congratulations! Here are the SQLs and stats." }
];


const ShowMessage = (props) => {
    return (<Alert severity={props.severity} >{props.message}</Alert>);
}

const ErrorMessageDisplay = (props) => {
    const { flag } = props;
    const message = (informationTexts.filter(msg => msg.code === flag))[0];

    return (
        message && message.severity && <ShowMessage {...message} />
    );
};

export default ErrorMessageDisplay;